// Utility for creating URL-safe slugs from headings in both English and Arabic
export function slugify(text: string): string {
  return text
    .toLowerCase()
    // Replace Arabic characters and spaces with hyphens
    .replace(/[\u0600-\u06FF\s]+/g, '-')
    // Replace English spaces and special characters
    .replace(/[^\w\u0600-\u06FF]+/g, '-')
    // Remove leading/trailing hyphens
    .replace(/^-+|-+$/g, '')
    // Collapse multiple hyphens
    .replace(/-+/g, '-');
}

export function generateTocFromSections(sections: Array<{ heading: string }>): Array<{ id: string; title: string }> {
  return sections.map(section => ({
    id: slugify(section.heading),
    title: section.heading
  }));
}